import axios from "axios";
import {
  OPERATOR_BYID,
  OPERATOR_LIST,
  SUPER_ADMIN_LIST,
} from "../../Store/Type";
import { toast } from "react-toastify";
const apiUrl = process.env.REACT_APP_API_URL;

const Get_Super_Admin_Url = `${apiUrl}/Operators-withAll-data`;
console.log(apiUrl, "apiUrlapiUrl555");
const api = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

const user = sessionStorage.getItem("USER_ID");

export const GetOperatorData = async (dispatch) => {
  try {
    // const response = await axios.get(`${apiUrl}/Operators-withAll-data`);
    const response = await axios.get(`${apiUrl}/get-operators/${user}`);

    dispatch({ type: OPERATOR_LIST, payload: response.data });
    return response.data;
  } catch (error) {
    handleError(error);
    // return null;
  }
};

export const handleOperatorSearch = async (e, dispatch) => {
  try {
    if (e.target.value) {
      const searchTerm = e.target.value
      const response =
     await axios.get(`${apiUrl}/operators-search/${user}/${searchTerm}`);
      
      console.log(response.data,"searched data")
      dispatch({ type: OPERATOR_LIST, payload: response.data });
      return response.data;
    } else {
      GetOperatorData(dispatch);
    }
  } catch (error) {
    console.log(error);
    handleError(error);
  }
};

export const SubmitOperatorExcel = async (file,dispatch,setExcelData) => {
  const formData = new FormData();
  formData.append("xlsxFile", file);
  formData.append("tbs_user_id", user);
  const excelEndpoint = `${apiUrl}/excelupload`;
  const method = "post";

  try {
    const response = await api({
      url: excelEndpoint,
      method: method,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if(response.data.Inserted>0){ 
    toast.success("Inserted Successfully");
    }else{
      toast.warning("Operator already exist");
    }
    GetOperatorData(dispatch)
    return response.data;
  } catch (error) {
    console.error("Error uploading file:", error);
    toast.error("Missing Required Fields")
    return null;
  }finally{
    setExcelData();
  
  }
};

export const GetSuperAdminData = async (dispatch) => {
  try {
    // const response = await api.get(`${apiUrl}/Operators-withAll-data`);
    const response = await axios.get(`${apiUrl}/get-operators/${user}`);
    
    dispatch({ type: SUPER_ADMIN_LIST, payload: response.data });
    return response.data;
  } catch (error) {
    handleError(error);
    return null; // Return null or some default value to prevent throwing the error
  }
};

export const SubmitCompanyData = async (
  companyvalue,
  operatorID,
  enable,
  dispatch,
  fileList,
  setOperatorID
) => {
  const userId=sessionStorage.getItem("type_id")
  const formData = new FormData();
  formData.append("operator_id",companyvalue.operator_id)

  formData.append("company_name", companyvalue.companyname);
  formData.append("owner_name", companyvalue.ownername);
  formData.append("phone", companyvalue.phone);
  formData.append("alternate_phone", companyvalue.phone);
  formData.append("emailid", companyvalue.emailid);
  formData.append("alternate_emailid", companyvalue.emailid);
  formData.append("aadharcard_number", companyvalue.aadhar);
  formData.append("pancard_number", companyvalue.pan);
  formData.append("tbs_user_id", user);
   formData.append("user_status", "Active");
    formData.append("req_status", "Active");
    formData.append("user_status_id", 2);
    formData.append("req_status_id", 2);
  //  if (userId!=="PRO101"&&enable === false) {
  //   formData.append("user_status", "Draft");
  //   formData.append("req_status", "Draft");
  //   formData.append("user_status_id", 0);
  //   formData.append("req_status_id", 0);
   
  //  }
  formData.append("profileimg", fileList[0]?.originFileObj);

  // const payload = {
  //   company_name: companyvalue.companyname,
  //   owner_name: companyvalue.ownername,
  //   phone: companyvalue.phone,
  //   alternate_phone: companyvalue.phone,
  //   emailid: companyvalue.emailid,
  //   alternate_emailid: companyvalue.emailid,
  //   aadharcard_number: companyvalue.aadhar,
  //   pancard_number: companyvalue.pan,
  //   user_status: "draft",
  //   req_status: "pending",
  //   user_status_id: 0,
  //   req_status_id: 0,
  // };
  console.log(operatorID, "operatorIDoperatorIDoperatorID");
  const updateurl = `${apiUrl}/operator/${
    operatorID ? operatorID : sessionStorage.getItem("SPA_ID")
  }`;
  const isUpdating = Boolean(operatorID);
  const submiturl = `${apiUrl}/operators`;
  // const method = operatorID ? "put" : "post";
  const method = isUpdating ? "put" : "post";
  const url = isUpdating ? updateurl : submiturl;
  try {
    const response = await api({
      method,
      url,
      // data: payload,
      data: formData,
      headers: {
        // "Content-Type": "application/json",
        "Content-Type": "multipart/form-data",
      },
    });
    sessionStorage.setItem("SPA_ID", response?.data?.id);
    GetOperatorData(dispatch);
    GetOperatorProfile(
      sessionStorage.getItem("SPA_ID") === null ||
        sessionStorage.getItem("SPA_ID") === "null" ||
        sessionStorage.getItem("SPA_ID") === undefined ||
        sessionStorage.getItem("SPA_ID") === "undefined"
        ? operatorID
        : sessionStorage.getItem("SPA_ID"),
      dispatch
    );
    setOperatorID(response?.data?.id ? response?.data?.id : operatorID);
    console.log(response?.data?.id, "respnse_submit_company_details");

    return response.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const validateMobile = async (value, module) => {
  const apiString =
    module === "operator"
      ? "phone"
      : module === "partner"
      ? "phone-partner"
      : module === "client"
      ? "phone-client"
      : "";
  try {
    const response = await axios.post(`${apiUrl}/${apiString}`, {
      phone: value,
    });
    return response.data.exists;
  } catch (err) {
    // handleError(err)
    console.log(err, "eroihfdjf");
    return err;
  }
};

export const validateEmail = async (value, module) => {
  const apiString =
    module === "operator"
      ? "emailid"
      : module === "partner"
      ? "emailid-partner"
      : module === "client"
      ? "emailid-client"
      : "";
  try {
    const response = await axios.post(`${apiUrl}/${apiString}`, {
      emailid: value,
    });
    return response.data.exists;
  } catch (err) {
    // handleError(err)
    console.log(err, "eroihfdjf");
  }
};

export const SubmitAddressData = async (
  addressvalue,
  operatorID,
  enable,
  dispatch
) => {
  const payload = {
    address: addressvalue.address,
    state: addressvalue.state,
    region: addressvalue.region,
    city: addressvalue.city,
    country: addressvalue.country,
    zip_code: addressvalue.postal,
    state_id: "TN",
    country_id: "IN",
    city_id: "39",
  };

  // const url = updatedata
  //   ? `${apiUrl}/operator_details/${updatedata}`
  //   : "${apiUrl}/operator_details";

  const method = enable ? "put" : "post";
  const url = `${apiUrl}/operator_details/${
    operatorID ? operatorID : sessionStorage.getItem("SPA_ID")
  }`;
  // const method ="post";
  try {
    const response = await api({
      method,
      url,
      data: payload,
      headers: {
        "Content-Type": "application/json",
      },
    });
    GetOperatorData(dispatch);
    console.log(response, "responseresponse");
    return response.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const SubmitBusinessData = async (
  businessvalues,
  operatorID,
  enable,
  dispatch
) => {
  const payload = {
    type_of_constitution: businessvalues.constitution,
    business_background: businessvalues.business,
    msme_type: businessvalues.msme,
    msme_number: businessvalues.msme_number,
    type_of_service: businessvalues.service,
    currency_code: businessvalues.currency_code,
  };

  // const url = updatedata
  //   ? `${apiUrl}/operator_details/${updatedata}`
  //   : "${apiUrl}/operator_details";

  // const method = updatedata ? "put" : "post";
  const url = `${apiUrl}/operator_details/${
    operatorID ? operatorID : sessionStorage.getItem("SPA_ID")
  }`;
  // const method = "post";
  const method = enable ? "put" : "post";
  try {
    const response = await api({
      method,
      url,
      data: payload,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    GetOperatorData(dispatch);
    console.log(response, "responseresponse");
    return response.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};
export const SubmitBusData = async (
  busdata,
  operatorID,
  enable,
  dispatch
) => {
  const formData = new FormData();
  formData.append("bus_img1", busdata.bus_img1);
  formData.append("bus_img2", busdata.bus_img2);
  formData.append("bus_img3",busdata.bus_img3);
  formData.append("bus_img4", busdata.bus_img4);
  formData.append("bus_img5", busdata.bus_img5);
   formData.append("bus_img6", busdata.bus_img6);
  

  const url = `${apiUrl}/upload/bus/images/${operatorID}`;
  const method = 'put'

  try {
    const response = await api({
      method,
      url,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    console.log(response, "responseresponse");
    GetOperatorData(dispatch);
    return response.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const SubmitDocumentsData = async (
  documentsdata,
  operatorID,
  enable,
  dispatch
) => {
  const formData = new FormData();
  formData.append("aadar_front_doc", documentsdata.aadhar_front);
  formData.append("aadar_back_doc", documentsdata.aadhar_back);
  formData.append("pancard_front_doc", documentsdata.pan_front);
  formData.append("pancard_back_doc", documentsdata.pan_back);
  formData.append("msme_docs", documentsdata.msme_docs);
  console.log(documentsdata.msme_docs, "memedocuments");
  console.log(documentsdata.pan_back, "memedocuments1")

  const url = `${apiUrl}/operator_details/${
    operatorID ? operatorID : sessionStorage.getItem("SPA_ID")
  }`;
  const method = enable ? "put" : "post";

  try {
    const response = await api({
      method,
      url,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    console.log(response, "responseresponse");
    GetOperatorData(dispatch);
    return response.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const SubmitProfileData = async (
  filedata,
  operatorID,
  enable,
  dispatch
) => {
  const formData = new FormData();
  formData.append("profileimg", filedata);

  const url = `${apiUrl}/operator-profileImg/${
    operatorID ? operatorID : sessionStorage.getItem("SPA_ID")
  }`;
  const method = "put";

  try {
    const response = await api({
      method,
      url,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    console.log(response, "responseresponse");
    GetOperatorData(dispatch);
    return response.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const GetSuperAdminGSTById = async (
  operatorID,
  setOperatorID,
  setSuperAdminGSTData,
  setSpinning
) => {
  console.log(operatorID, "ahsgxdahsjksaxbj");
  const getid = sessionStorage.getItem("OPERATE_ID")
    ? sessionStorage.getItem("OPERATE_ID")
    : sessionStorage.getItem("SPA_ID");
  try {
    const response = await api.get(`${apiUrl}/get-GST/${getid}`);
    console.log(response, "responseresponse");
    // SetUpdateData(null);
    setSuperAdminGSTData(response?.data[0]);
    return response?.data[0];
  } catch (error) {
    handleError(error);
    return null;
  } finally {
    setSpinning && setSpinning(false);
  }
};

export const SubmitGSTData = async (
  documentsdata,
  operatorID,
  setSuperAdminGSTData,
  superadmingstdata,
  dispatch
) => {
  console.log(documentsdata, "documentsdata");
  const formData = new FormData();
  formData.append(
    "aggregate_turnover_exceeded",
    documentsdata.ctc == 1 ? true : false
  );
  formData.append("state_name", documentsdata.state);
  formData.append("state_code_number", documentsdata.state_code);
  formData.append("gstin", documentsdata.gst);
  formData.append("head_office", documentsdata.head_office);
  formData.append("upload_gst", documentsdata.gst_file);
  formData.append("has_gstin", "true");

  if (superadmingstdata?.user_status_id == 0) {
    formData.append("user_status", "Posted");
    formData.append("user_status_id", 1);
    formData.append("req_status", "Pending");
    formData.append("req_status_id", 1);
  }

  const url = sessionStorage.getItem("OPERATE_ID")
    ? `${apiUrl}/operator_details/${sessionStorage.getItem("OPERATE_ID")}`
    : `${apiUrl}/operator_details/${sessionStorage.getItem("SPA_ID")}`;
  const method = sessionStorage.getItem("OPERATE_ID") ? "put" : "post";
  // const url = `${apiUrl}/operator_details/${operatorID}`;
  // const method = "post";
  try {
    const response = await api({
      method,
      url,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    // GetSuperAdminData(dispatch);
    GetSuperAdminGSTById(
      sessionStorage.getItem("OPERATE_ID"),
      null,
      setSuperAdminGSTData
    );
    setSuperAdminGSTData("");
    GetOperatorData(dispatch);
    console.log(response, "responseresponse");
    return response.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const GetSuperAdminById = async (
  updatedata,
  SetUpdateData,
  setOfferData
) => {
  console.log(updatedata, "ahsgxdahsjksaxbj");
  try {
    const response = await api.get(`${apiUrl}/all-operators/${updatedata}`);
    console.log(response, "responseresponse");
    // SetUpdateData(null);
    // setOfferData("");
    console.log(response.data, "get_super_admin_by_id");
    sessionStorage.setItem("OPERATE_ID", response.data[0]?.tbs_operator_id);
    return response?.data[0];
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const GetSuperAdminAddressById = async (
  OperatorID,
  setOperatorID,
  setSuperAdminAddressData,
  setSpinning
) => {
  try {
    const response = await api.get(
      `${apiUrl}/getall-address/${
        OperatorID ? OperatorID : sessionStorage.getItem("SPA_ID")
      }`
    );
    console.log(response, "responseresponse");
    // SetUpdateData(null);
    setSuperAdminAddressData("");
    return response?.data[0];
  } catch (error) {
    handleError(error);
    return null;
  } finally {
    setSpinning && setSpinning(false);
  }
};

export const GetSuperAdminBusinessById = async (
  OperatorID,
  SetUpdateData,
  setOfferData,
  setSpinning
) => {
  try {
    const response = await api.get(
      `${apiUrl}/get-business/${
        OperatorID ? OperatorID : sessionStorage.getItem("SPA_ID")
      }`
    );
    console.log(response, "responseresponse");
    // SetUpdateData(null);
    setOfferData("");
    return response?.data[0];
  } catch (error) {
    handleError(error);
    return null;
  } finally {
    setSpinning && setSpinning(false);
  }
};

export const GetSuperAdminDocumentById = async (
  updatedata,
  SetUpdateData,
  setOfferData,
  setSpinning
) => {
  console.log(updatedata, "ahsgxdahsjksaxbj");
  const getid = sessionStorage.getItem("SPA_ID");
  try {
    const response = await api.get(
      `${apiUrl}/get-Docs/${updatedata ? updatedata : getid}`
    );
    console.log(response, "responseresponse");
    // SetUpdateData(null);
    setOfferData("");
    return response?.data[0];
  } catch (error) {
    handleError(error);
    return null;
  } finally {
    setSpinning && setSpinning(false);
  }
};

export const GetOperatorById = async (
  OperatorID,
  setOperatorID,
  setSuperAdminData,
  dispatch,
  setSpinning
) => {
  try {
    const response = await api.get(
      `${apiUrl}/all-operators/${
        OperatorID ? OperatorID : sessionStorage.getItem("SPA_ID")
      }`
    );
    // dispatch({ type: OPERATOR_BYID, payload: response.data })
    // SetUpdateData(null);
    setSuperAdminData("");
    console.log(response?.data, "whichOperatorGetWOrks");
    return response?.data;
  } catch (error) {
    handleError(error);
    return null;
  } finally {
    setSpinning(false);
  }
};

// export const GetOperatorProfile = async (operatorID) => {
//   console.log(operatorID, "operatorID852");
//   try {
//     const response = await axios.get(
//       `${apiUrl}/operators-profileImg/${operatorID}
//       }`
//     );
//     // dispatch({ type: OPERATOR_LIST, payload: response.data });
//     console.log(response.data, 'GetOperatorProfile')
//     sessionStorage.setItem('OperatorProfileImg', response.data[0].profileimg)
//     return response.data;
//   } catch (error) {
//     handleError(error);
//     // return null;
//   }
// };

export const GetOperatorProfile = async (operatorID, dispatch) => {
  console.log(operatorID, "operatorID852");

  if (!operatorID) {
    return null;
  }

  try {
    const response = await axios.get(
      `${apiUrl}/operators-profileImg/${
        operatorID !== undefined
          ? operatorID
          : sessionStorage.getItem("OPERATE_ID")
      }`
    );
    console.log(response.data, "GetOperatorProfile");
    dispatch({ type: OPERATOR_BYID, payload: response.data });
    sessionStorage.setItem("OperatorProfileImg", response.data[0]?.profileimg);
    console.log(response.data, "get_operator_profile");
    return response.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};

export const GetCurrencyList = async () => {
  try {
    const response = await axios.get(`${apiUrl}/currency-code`);
    console.log((response.data, "currency"));
    return response.data;
  } catch (err) {
    handleError(err);
  }
};

export const GetBusinessList = async () => {
  try {
    const response = await axios.get(`${apiUrl}/bussiness-categories`);
    return response.data;
  } catch (err) {
    handleError(err);
  }
};

export const OperatorProfile = async (image, operatorID) => {
  console.log(image, "image987465222");
  const payload = new FormData();
  payload.append("profileimg", image);

  const updateurl = `${apiUrl}/operator-profileImg/${operatorID}`;

  const method = "put";
  try {
    const response = await api({
      method,
      url: updateurl,
      data: payload,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    GetOperatorProfile();
    //GetOperatorData();
    console.log(response, "responseresponse");
    return response.data;
  } catch (error) {
    handleError(error);
    return null;
  }
};
export const GetOperatorByOPId = async (operatorId) => {
  console.log(operatorId, "operatorId");
  try {
    const response = await api.get(`${apiUrl}/operators/${operatorId}`);
    return response.data[0];
  } catch (error) {
    handleError(error);
  }
};

const handleError = (error) => {
  console.error("Error details:", error);
  let errorMessage = "An error occurred";

  if (error.response) {
    console.error("Error response from server:", error.response);
    errorMessage = `Server responded with status ${error.response.status}`;
  } else if (error.request) {
    console.error("No response received:", error.request);
    errorMessage = "No response received from server";
  } else {
    console.error("Error setting up request:", error.message);
    errorMessage = error.message;
  }

  if (error.code === "ERR_NETWORK") {
    errorMessage =
      "Network Error: Unable to connect to the server. Please check the server status and your network connection.";
  }

  toast.error(errorMessage);
};
